import { jwtDecode } from "jwt-decode";
export default {
  tieneRol: state => idsRol => {
    return state.local && idsRol.some(idRol => state.local.rol.idRol == idRol);
  },
  getDiasRendicion: state => {
    return state.diasRendicion[state.local.fspCodigo] || [];
  },
  getTiposObservacionesLocal: state => state.tiposObservacionesLocal,
  getTiposSitEmergentesExam: state => state.tiposSitEmergentesExam,
  getFase: state => state.local?.fspCodigo,
  getPruebas(state) {
    const { fspCodigo } = state.local;
    return state.pruebas[fspCodigo] || [];
  },
  getPrueba(state, getters) {
    const map = getters.getPruebas.reduce((acc, prueba) => {
      acc[prueba.pruCodigo] = prueba;
      return acc;
    }, {});
    return function (codigo) {
      return map[codigo] || {};
    };
  },
  getPaises: state => state.paises,
  esConsultor: () => {
    const token = window.localStorage.getItem('token');
    const {roles} = jwtDecode(token);
    return roles.includes('CONSULTOR');
  }
};
